import CommonBubble from '@home/components/CommonBubble';
import React from 'react';
import { Progress } from 'tea-component';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import { DEFAULT_IMG } from '@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRRadarChart/utils';
import './getRender.scss';
import BasicImage from '@home/components/BasicImage';

export const getColor = (
  value: string,
  colorList: string[],
  low: string,
  mid: string,
) => {
  let color;
  if (value) {
    if (Number(value) <= Number(low)) {
      color = colorList?.[0];
    } else if (Number(value) <= Number(mid)) {
      color = colorList?.[1];
    } else {
      color = colorList?.[2];
    }
  }
  return color;
};

export const getStudioScoreDom = (
  value: string,
  item: any,
  colorList: string[],
  descKey: string,
  isDark: boolean,
) => {
  const {
    benchmark_low = 3,
    benchmark_mid = 6,
    benchmark_high = 10,
    [descKey]: desc,
  } = item || {};
  const bgColor = getColor(value, colorList, benchmark_low, benchmark_mid);

  return (
    <div className="dbh-benchmark-studio-table-content-td-score">
      <CommonBubble
        style={{ maxWidth: '516px' }}
        content={desc && <FormatHtmlTextToReact text={desc} />}
      >
        <span
          style={{
            ...(value ? { color: '#000' } : {}),
            ...(bgColor && isDark ? { filter: 'invert(100%)' } : {}),
          }}
        >
          {value || '-'}
        </span>
        <Progress
          percent={
            value && benchmark_high
              ? (Number(value) / Number(benchmark_high)) * 100
              : 0
          }
          strokeColor={bgColor}
          strokeWidth={8}
        />
      </CommonBubble>
    </div>
  );
};

export const getStudioMoreScoreDom = (
  version: string[],
  gameCover: string[],
  item: any,
  colorList: string[],
) => {
  const {
    benchmark_low = 3,
    benchmark_mid = 6,
    benchmark_high = 10,
    studioList = [],
  } = item || {};

  return (
    <div className="dbh-benchmark-studio-table-content-td-more-score">
      {version?.map((studio: any, index: number) => {
        const { key, value } = studioList.find(item => item.name === studio) || {};
        const bgColor = getColor(
          value,
          colorList,
          benchmark_low,
          benchmark_mid,
        );
        return (
          <div
            key={key}
            className="dbh-benchmark-studio-table-content-td-more-score-item"
          >
            <BasicImage src={gameCover?.[index] || DEFAULT_IMG} />
            <div className="dbh-benchmark-studio-table-content-td-more-score-item-progress">
              <Progress
                percent={100}
                strokeColor={bgColor}
                strokeWidth={8}
                style={{
                  width:
                    value && benchmark_high
                      ? `${(Number(value) / Number(benchmark_high)) * 100}%`
                      : 0,
                }}
              />
              <span>{value || '-'}</span>
            </div>
          </div>
        );
      })}
      <div className='dbh-benchmark-studio-table-content-td-more-score-item-wrap'>
        <div
          className="dbh-benchmark-studio-table-content-td-more-score-item-wrap-line"
          style={{ left: `calc(${benchmark_low / benchmark_high * 100}%)`, borderColor: colorList[0] }}
        ></div>
        <div
          className="dbh-benchmark-studio-table-content-td-more-score-item-wrap-line"
          style={{ left: `calc(${benchmark_mid / benchmark_high * 100}%)`, borderColor: colorList[1] }}
        ></div>
        <div
          className="dbh-benchmark-studio-table-content-td-more-score-item-wrap-line"
          style={{ left: `calc(${benchmark_high / benchmark_high * 100}%)`, borderColor: colorList[2] }}
        ></div>
      </div>
    </div>
  );
};

export const getStudioDescDom = (
  item: any,
  expand: boolean,
  studio: any
) => {
  const descItem = item?.studioList?.find((v:any) => v?.studio === studio) || item?.studioList?.[0] || {};

  return (
    <div className="dbh-benchmark-studio-table-content-td-desc">
      <div style={{ height: expand ? '100%' : item?.studioList?.length * 24, WebkitLineClamp: expand ? '' : item?.studioList?.length }}>
        <FormatHtmlTextToReact text={descItem?.desc} />
      </div>
    </div>
  );
};
